import React from 'react';
import { Box, Typography } from '@mui/material';

interface CastcoLogoProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'header' | 'sidebar' | 'login';
  onClick?: () => void;
}

const CastcoLogo: React.FC<CastcoLogoProps> = ({
  size = 'medium',
  variant = 'header',
  onClick
}) => {
  const getSizeStyles = () => {
    switch (size) {
      case 'small':
        return {
          fontSize: '1.2rem',
          padding: '6px 12px',
          minWidth: '120px',
          letterSpacing: '1px'
        };
      case 'large':
        return {
          fontSize: '2.5rem',
          padding: '16px 32px',
          minWidth: '250px',
          letterSpacing: '3px'
        };
      default: // medium
        return {
          fontSize: '1.5rem',
          padding: '8px 16px',
          minWidth: '150px',
          letterSpacing: '2px'
        };
    }
  };

  const getVariantStyles = () => {
    switch (variant) {
      case 'sidebar':
        return {
          backgroundColor: 'transparent',
          color: 'primary.main',
          border: '2px solid',
          borderColor: 'primary.main',
          '&:hover': {
            backgroundColor: 'primary.main',
            color: 'white',
            transform: 'scale(1.02)'
          }
        };
      case 'login':
        return {
          backgroundColor: '#dc143c',
          color: 'white',
          border: '2px solid #b71c1c',
          boxShadow: '0 6px 12px rgba(220, 20, 60, 0.3)',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 16px rgba(220, 20, 60, 0.4)'
          }
        };
      default: // header
        return {
          backgroundColor: '#dc143c',
          color: 'white',
          border: '2px solid #b71c1c',
          boxShadow: '0 2px 4px rgba(220, 20, 60, 0.2)',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 4px 8px rgba(220, 20, 60, 0.3)'
          }
        };
    }
  };

  const sizeStyles = getSizeStyles();
  const variantStyles = getVariantStyles();

  return (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: onClick ? 'pointer' : 'default',
        borderRadius: '8px',
        fontWeight: 'bold',
        fontFamily: '"Roboto", "Arial", sans-serif',
        textAlign: 'center',
        transition: 'all 0.3s ease',
        ...sizeStyles,
        ...variantStyles
      }}
    >
      <Typography
        component="span"
        sx={{
          fontWeight: 'bold',
          fontSize: 'inherit',
          letterSpacing: 'inherit'
        }}
      >
        CASTCO
      </Typography>
    </Box>
  );
};

export default CastcoLogo;
